import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: "auto",
		marginBottom: theme.spacing(6),
		padding: theme.spacing(1),
	},
	heading: {
		fontWeight: "bold",
		marginBottom: theme.spacing(1),
		color: theme.palette.text.primary, // Use theme text color
		fontSize: "0.9rem",
	},
	contactItem: {
		marginBottom: theme.spacing(1),
		fontSize: "0.8rem",
		color: theme.palette.text.primary, // Use theme text color
		"&:last-child": {
			marginBottom: 0,
		},
	},
	emailLink: {
		fontWeight: "bold",
		color: theme.palette.text.secondary, // Gray link color
		textDecoration: "none",
		"&:hover": {
			textDecoration: "underline",
		},
	},
	websiteLink: {
		fontWeight: "bold",
		color: theme.palette.text.secondary, // Gray link color
		textDecoration: "none",
		"&:hover": {
			textDecoration: "underline",
		},
	},
}));

const ContactSection = () => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.contactItem}>
				<a
					className={classes.emailLink}
					href="mailto:support@fortherecord.pro"
				>
					support@fortherecord.pro
				</a>
			</div>
			<div className={classes.contactItem}>
				<a
					className={classes.websiteLink}
					href="https://www.fortherecord.pro"
					target="_blank"
					rel="noopener noreferrer"
				>
					www.fortherecord.pro
				</a>
			</div>
		</div>
	);
};

export default ContactSection;
